module.exports = __webpack_public_path__ + "img/icon-agencia-tributaria.e438ebe8.svg";